import * as React from 'react';

const GoalEvent = ({ size }: { size?: number }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M18.4 18.3c.3-.3.5-.8.5-1.3v-6c0-1.1-.9-2-2-2H6.1c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2H17l1.3 1.3 1-1.1-.9-.9zm-1.6-1.7c.1-.1.2-.3.2-.6v-4c0-.5-.4-1-1-1H7c-.6 0-1 .4-1 1v4c0 .5.4 1 1 1h5.8l-1-4.2 4.7 1.1-1.6.9 1.9 1.8zM15 17h-1.8l.7-1.1L15 17zM8.606 4.196l.961-.276.827 2.884-.961.276-.827-2.884zM4.098 5.768l.719-.695 2.084 2.158-.719.695-2.084-2.158zm14.084-.694l.719.695-2.084 2.158-.719-.695 2.084-2.158zM13.433 3.92l.961.276-.827 2.884-.961-.276.827-2.884z"
      fillRule="evenodd"
    />
  </svg>
);

export default GoalEvent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Icon/GoalEvent.tsx